import {useTranslation} from 'react-i18next'
import {HelpIcon} from '@/components/help-icon'

export function RegimeExpandedStamp({chapter, prevChapter}: {chapter: number; prevChapter: number | undefined}) {
  const {t} = useTranslation()
  if (prevChapter === undefined || chapter <= prevChapter) return null
  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        data-testid="regime-expanded"
        className="inline-flex items-center rounded-sm bg-secondary px-1.5 py-0.5 font-mono text-[10px] font-medium tracking-wider text-foreground uppercase">
        {t('sgsst.regimeExpanded', {from: prevChapter, to: chapter})}
      </span>
      <HelpIcon label={t('common.help.iconLabel')} testId="regime-expanded-help">
        {t('sgsst.regimeExpandedHelp')}
      </HelpIcon>
    </span>
  )
}
